import t from "../../../helpers/t";
import FormItem from "../../../components/FormItem";
import React, {useEffect, useState} from "react";

const ContingentsChange = (props) => {
    const { voucherType, setVoucherType, dispatch} = props;
    const [selectedContingents,setSelectedContingents] = useState(voucherType.contingents);
    useEffect(() => {
        change();
    },[selectedContingents]);
    const onChangeContingent = (item) => {
        change();
    }
    const addContingents = (contingent) => {
        let contingentIds = [];
        selectedContingents.map(sel =>{
            contingentIds.push({
                id: sel.id,
                name: sel.name
            });
        });
        contingentIds.push({
            id: contingent.id,
            name: contingent.name
        });
        let clone = {};
        Object.assign(clone, voucherType);
        console.log(contingentIds);
        clone.contingents = contingentIds;
        setVoucherType(clone);
    }
    const change = () => {
        let clone = {};
        Object.assign(clone,voucherType);
        let contingentIds = [];
        selectedContingents.map(sel =>{
            contingentIds.push({
                id: sel.id,
                name: sel.name
            });
        });
        clone.contingents = contingentIds;
        setVoucherType(clone);
    }

    const onRemoveContingent = (index) => {
        const newContingents = selectedContingents.slice(0);
        newContingents.splice(index, 1);
        setSelectedContingents(newContingents);
        change();
    };

    const fields =  {
        fieldMap: {
            id: {
                label: t("id"),
                number: "1",
                class: "inb-select-width-1",
                type: 'default',
                style: {maxWidth: "20%", padding: 0}
            },
            name: {
                label: t("name"),
                number: "2",
                class: "inb-select-width-3",
                type: 'default',
                style: {maxWidth: "35%", padding: 0}
            },
            description: {
                label: t('description'),
                number: "3",
                class: "inb-select-width-3",
                type: 'default'
            }
        },
        fieldNames: [
            "id", "name", "description"
        ]
    };
    const searchParams = {
        param: "q",
        checkFields: ["name"]
    };
    const disabled= typeof props.disabled !== 'undefined'?props.disabled:'';
    return ( <>
        <FormItem
            name="contingents"
            type="inboomaSelect"
            id={"voucher_types_contingents_"+(typeof voucherType.id !== 'undefined'?voucherType.id:'new')}
            sortBy={'name'}
            sortDirection={'asc'}
            advanced={true}
            placeholder={t('select_${a}',{a:t('contingent')})}
            selectedItems={selectedContingents}
            setSelectedItems={setSelectedContingents}
            onChangeHandler={addContingents}
            dispatch={dispatch}
            container='location-vcard'
            extraStyle={{maxWidth:"750px"}}
            multiSelect={true}
            onReset={onRemoveContingent}
            fields={fields}
            searchParams={searchParams}
            model={'contingent'}
            disabled={disabled}
            label={t('contingent',null,'capital')}
           // helpText={t('contingent_location_help')}
            mediumWidth={12}
            smallWidth={12}
        />
    </>);
}
export default ContingentsChange;